import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { CardGreyHeadline, CardInner } from 'components/Card'
import classNames from 'classnames'
import text from 'styles/utility/text.module.scss'
import { PackageSize } from 'types/storeDeliveryFee'
import { Spacer } from '../../Utility'

type Props = {
  headline: string
  packageSize: PackageSize
  title: string
}

const StoreDeliveryFeePackageSize: FC<Props> = (props) => {
  const { headline, packageSize, title } = props

  return (
    <div className={styles.settings}>
      <div className={styles.settings__header}>
        <h4 className={styles.settings__header__title}>{title}</h4>
      </div>
      <CardGreyHeadline headline={headline} />
      <Spacer size={8} />
      <CardInner>
        <p className={classNames(text.font_small)}>
          <span className={classNames(text.color_caution, text.font_bold)}>{packageSize}サイズ</span>
        </p>
      </CardInner>
      <Spacer size={8} />
    </div>
  )
}

export default StoreDeliveryFeePackageSize
